export default {
    'configuration': true,
    'searchList': {
        'searchTxt': [
            {
                'name': '排单编号',
                'value': 'lineCode',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '车次号',
                'value': 'trainNum',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '客户订单号',
                'value': 'customerOrderNo',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '运输单号',
                'value': 'taskNo',
                'type': 'input',
                'unfold': true,
                'span': 2
            },
            {
                'name': '状态',
                'value': 'lineStatus',
                'type': 'select',
                'options': [
                    { 'label': '未开始', 'value': '0' },
                    { 'label': '进行中', 'value': '10' },
                    { 'label': '排单成功', 'value': '20' },
                    { 'label': '排单失败', 'value': '30' }
                ],
                'unfold': true,
                'span': 2
            },
            {
                'name': '分公司',
                'value': 'companyName',
                'unfold': true,
                'type': 'advance',
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '分公司名称' },
                    { 'prop': 'escoCompanyNo', 'value': '分公司编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '分公司名称' },
                    { 'prop': 'escoCompanyNo', 'value': '分公司编码' }
                ],
                'advanceUrl': '/searchBrand',
                'cbParams': ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
                'span': 3
            },
            {
                'name': '服务平台',
                'value': 'siteName',
                'unfold': true,
                'type': 'advance',
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '名称' },
                    { 'prop': 'escoCompanyNo', 'value': '编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '平台编码' }
                ],
                'advanceUrl': '/searchPlatform',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 3
            },
            {
                'name': '创建时间',
                'value': 'createTime',
                'type': 'time',
                'unfold': true,
                'timeNum': 3,
                'span': 5,
                'startPlaceholder': '开始时间',
                'endPlaceholder': '结束时间'
            }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    table: {
        'clickModify': true,
        'selectBtn': true,
        'leftWidth': 160,
        'height': '400px',
        'leftOperation': false,
        'columns': [
            {
                'label': '状态',
                'prop': 'lineStatusName',
                'width': 100,
                'sort': true
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'width': 140,
                'sort': true
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': 140,
                'sort': true
            },
            {
                'label': '排单编号',
                'prop': 'lineCode',
                'type': 'button',
                'width': 160,
                'sort': true
            },
            {
                'label': '用时(秒)',
                'prop': 'processingTime',
                'width': 120,
                'sort': true
            },
            {
                'label': '排单开始时间',
                'prop': 'lineStartTime',
                'width': 160,
                'sort': true
            },
            {
                'label': '排单结束时间',
                'prop': 'lineEndTime',
                'width': 160,
                'sort': true
            },
            {
                'label': '订单数',
                'prop': 'totalOrderNum',
                'width': 120,
                'sort': true
            },
            {
                'label': '车次数',
                'prop': 'lineNum',
                'width': 140,
                'sort': true
            },
            {
                'label': '方数(m³)',
                'prop': 'totalVolume',
                'width': 140,
                'sort': true
            },
            {
                'label': '失败原因',
                'prop': 'orderFailReason',
                'width': 160,
                'sort': true
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': 100,
                'sort': true
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': 160,
                'sort': true
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50]
    },
    // 高级搜索配置项
    'searchTotalTitle': []
};
